import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getGroup(id) {
        return axios.get(config.publicPath + 'link_groups/' + id, {
            headers: JsonHeaders
        });
    },
    getGroups(currentPage, perPage, user_id, name, type) {
        return axios.get(config.publicPath + 'link_groups', {
            params: {
                _page: currentPage,
                itemsPerPage: perPage,
                "user.id": user_id,
                name: name,
                type: type
            },
            headers: JsonHeaders
        });
    },
    getGroupSelect(type) {
        return axios.get(config.publicPath + 'link_groups', {
            params: {'groups[]': 'select', 'pagination': false, type: type},
            headers: JsonHeaders
        });
    },
    createGroup(data) {
        return axios.post(config.publicPath + 'link_groups', data, {
            headers: JsonHeaders
        });
    },
    updateGroup(id, data) {
        return axios.put(config.publicPath + 'link_groups/' + id, data, {
            headers: JsonHeaders
        });
    },
    deleteGroup(id) {
        return axios.delete(config.publicPath + 'link_groups/' + id, {
            headers: JsonHeaders
        });
    }
}